import React, { useState, useEffect } from 'react';
import { Button } from "./ui/button";
import { translations } from '../data/translations';
import { PrivacyDialog } from './PrivacyDialog';
import { motion, AnimatePresence } from 'framer-motion';

export const ConsentBanner = ({ lang }) => {
  const [show, setShow] = useState(false);
  const t = translations[lang].footer.consent;

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-[100] p-4 bg-zinc-950/95 backdrop-blur-md border-t border-zinc-800 shadow-2xl"
        >
          <div className="container mx-auto max-w-4xl flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-300 text-sm md:text-base text-center md:text-left">
              {t.text}
            </p>
            <div className="flex gap-4 shrink-0">
              <PrivacyDialog lang={lang}>
                <Button variant="outline" className="text-xs border-zinc-700 hover:bg-zinc-800 text-white hover:text-white">
                  {t.read_more}
                </Button>
              </PrivacyDialog>
              <Button onClick={handleAccept} className="bg-red-600 hover:bg-red-700 text-white font-bold text-xs px-6">
                {t.accept}
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
